import Sync from '@mui/icons-material/Sync'
import { MenuItem } from '@mui/material'
import { TemplateLayoutTypeEnum } from '@ulysses-inc/harami_api_client'
import { type MouseEvent, useRef, useState } from 'react'
import {
  editorPermissions,
  hasPermission,
} from 'src/libraries/roles/permissions'
import { MigrationDomainError } from '../domain/types'
import { useGridToTableMigration } from '../hooks/useGridToTableMigration'
import { MigrationDialogs } from './MigrationDialogs'

const EnabledMigrationMenuItem = ({
  templateId,
  onCloseMenu,
}: {
  templateId: number
  onCloseMenu: () => void
}) => {
  const [confirmOpen, setConfirmOpen] = useState(false)
  const [reasons, setReasons] = useState<string[]>([])
  const executionLocked = useRef(false)
  const migration = useGridToTableMigration()

  const openConfirmation = (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation()
    event.preventDefault()
    onCloseMenu()
    setReasons([])
    setConfirmOpen(true)
  }

  const confirm = async () => {
    if (executionLocked.current || migration.isPending) return
    executionLocked.current = true
    try {
      await migration.mutateAsync(templateId)
      setConfirmOpen(false)
    } catch (error) {
      if (error instanceof MigrationDomainError) {
        setConfirmOpen(false)
        setReasons(error.reasons)
      }
      // 通信・APIエラーはhookでSnackbar通知する。
      // 確認モーダルは閉じず、処理終了後に「変更する」から再実行できる。
    } finally {
      executionLocked.current = false
    }
  }

  return (
    <>
      <MenuItem
        disabled={migration.isPending}
        onClick={openConfirmation}
        sx={{ gap: 1 }}
      >
        <Sync />
        web版で使えるひな形に移行する
      </MenuItem>
      <MigrationDialogs
        confirmOpen={confirmOpen}
        reasons={reasons}
        isPending={migration.isPending}
        onCancel={() => setConfirmOpen(false)}
        onConfirm={confirm}
        onCloseReasons={() => setReasons([])}
      />
    </>
  )
}

export const GridToTableMigrationMenuItem = ({
  id,
  layoutType,
  onCloseMenu,
}: {
  id?: number
  layoutType?: TemplateLayoutTypeEnum
  onCloseMenu: () => void
}) => {
  if (
    id === undefined ||
    layoutType !== TemplateLayoutTypeEnum.Grid ||
    !hasPermission(editorPermissions)
  ) {
    return null
  }
  return <EnabledMigrationMenuItem templateId={id} onCloseMenu={onCloseMenu} />
}
